import React from 'react';
import {Flex} from "antd";
import { renderNumberCell } from '../../../numberFormat'

interface SummaryProps {
  label: string,
  value: number | string | JSX.Element,
  precision?: number,
}

export default function SummaryItem({value, label, precision = 0}: SummaryProps) {
  return (
    <Flex className={'summary__items-item'} vertical>
      <div className={'summary__items-item__label'}>{label}</div>
      <div className={'summary__items-item__value'}>{renderNumberCell(value, precision, { fontSize: '10px'})}</div>
    </Flex>
  )
}
